export default __webpack_public_path__ + "static/media/idea-mapping-template.c3b22f2c.pptx";